import React, { createContext } from 'react'

import { serverSideQuery, useQuery } from '@/api'

import { LAYOUT_ENDPOINT } from '../../constants'

import { LayoutContextType, LayoutParamsType, LayoutProviderProps, LayoutResponse } from './types'

const defaultContextValue = {
    state: {},
}

const LayoutContext = createContext<LayoutContextType>(defaultContextValue)
const { Provider } = LayoutContext

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children, initialParams, initialProps }) => {
    const state = useQuery<LayoutResponse>({
        endpoint: `${LAYOUT_ENDPOINT}/${initialParams?.productionId}`,
        initialFetchDisabled: !!initialProps?.data,
        initialData: initialProps?.data,
        enabled: !!initialParams?.productionId,
    })

    const contextValue: LayoutContextType = { state }

    return <Provider value={contextValue}>{children}</Provider>
}

export const serverSideRead = async (params: LayoutParamsType): Promise<LayoutResponse> => {
    const queryInstance = serverSideQuery<LayoutResponse>(`${LAYOUT_ENDPOINT}/${params.productionId}`)
    const layoutResponse = await queryInstance(params)

    return layoutResponse
}

export default LayoutContext
